// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"6f30e43c50cc6a93","5405":"ed985d4a014fd910","7699":"61604678c483bd8e","8672":"143077fa688812c0","9584":"0f50e6eb5ab4802a"}[chunkId] + ".css";
};